import { cx } from "@emotion/css";
import Skeleton from "library/Atoms/Skeleton";
import styles from "./styles";

const FastQuoteDetailsSkeleton = () => <Skeleton className={cx(styles.details, "w-100")} />;

export default FastQuoteDetailsSkeleton;
